import React from 'react';
import { ArrowRight, Briefcase, Users } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';

const CTASection = () => {
  const { theme } = useTheme();

  return (
    <section className={`relative py-16 sm:py-20 lg:py-24 transition-colors duration-300 ${
      theme === 'dark' ? 'bg-[#0a0a0a]' : 'bg-white'
    }`}>
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-[7.6923%]">
        <div className={`p-8 sm:p-10 lg:p-14 text-center ${
          theme === 'dark' ? 'bg-black border border-white/10' : 'bg-gray-50 border border-gray-200'
        }`}>
          <h2 className={`text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 ${
            theme === 'dark' ? 'text-white' : 'text-gray-900'
          }`}>
            Ready to Get Started?
          </h2>
          <p className={`text-base sm:text-lg mb-8 max-w-[600px] mx-auto ${
            theme === 'dark' ? 'text-white/60' : 'text-gray-600'
          }`}>
            Whether you're looking to hire top IT talent or find your next opportunity, we're here to help.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className={`group inline-flex items-center justify-center gap-2 px-6 py-3.5 font-medium text-base sm:text-lg transition-all duration-300 ${
                theme === 'dark'
                  ? 'bg-[#00FFD1] text-black hover:bg-[#00FFD1]/80'
                  : 'bg-[#00997A] text-white hover:bg-[#007A61]'
              }`}
            >
              <Briefcase size={20} />
              Request Consultation
              <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
            </Link>
            
            <Link
              to="/careers"
              className={`group inline-flex items-center justify-center gap-2 px-6 py-3.5 font-medium text-base sm:text-lg transition-all duration-300 ${
                theme === 'dark'
                  ? 'bg-white/10 text-white hover:bg-white/20 border border-white/20'
                  : 'bg-white text-gray-800 hover:bg-gray-100 border border-gray-300'
              }`}
            >
              <Users size={20} />
              Join Talent Network
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
